const openStatus = [
  { id: '0', name: '开启' },
  { id: '1', name: '关闭' }
]

const stockType = [
  { id: 1, name: '创始股' },
  { id: 2, name: '普通股' }
]

const stockExchangeStatus = [
  { id: 0, name: '委托中' },
  { id: 2, name: '已成交' },
  { id: 3, name: '已撤单' },
  { id: 4, name: '已打款' }
]

const opinionTypes = [
  { id: 1, name: '金点子' },
  { id: 2, name: '问题反馈' },
  { id: 3, name: '投诉' }
]

const tyyPakcageTypes = [
  { id: 1, name: '正式' },
  { id: 3, name: '体验' }
]

const opinionStatus = [
  { id: '0', name: '待处理' },
  { id: '1', name: '处理中' },
  { id: '10', name: '用户结单' },
  { id: '11', name: '总部结单' }
]

const gradeLists = [
  { id: '-2', name: '幼儿园小班' },
  { id: '-1', name: '幼儿园中班' },
  { id: '1', name: '幼儿园大班' },
  { id: '2', name: '一年级' },
  { id: '3', name: '二年级' },
  { id: '4', name: '三年级' },
  { id: '5', name: '四年级' },
  { id: '6', name: '五年级' },
  { id: '7', name: '六年级' },
  { id: '8', name: '初一' },
  { id: '9', name: '初二' },
  { id: '10', name: '初三' }
]

const tyySubjectLists = [
  { id: '1', name: '语文' },
  { id: '2', name: '英语' },
  { id: '3', name: '数学' }
]

const businessType = [
  { id: '1', name: '托管' },
  { id: '3', name: '小班课' }
]

const xxsSubjectLists = [
  { id: '1', name: '慧表达' },
  { id: '2', name: '英语' },
  { id: '3', name: '火花思维' },
  { id: '5', name: '国章书法' },
  { id: '15', name: '学习小组' },
  { id: '17', name: '新概念' },
  { id: '18', name: '四季数学' },
  { id: '19', name: '学习小组数学' },
  { id: '20', name: '学习小组英语' },
  { id: '21', name: '数学精品课' },
  { id: '22', name: '英语精品课' },
  // {id: '72', name: '乐之坊-人文美育'},
  // {id: '73', name: '乐之坊-英文素养'},
  // {id: '74', name: '乐之坊-创新思维'},
  { id: '75', name: '学习小组语文' },
  { id: '76', name: '语文精品课' },
  { id: '77', name: '科学' },
  { id: '78', name: '拼音' },
  { id: '79', name: '物理' },
  { id: '80', name: '化学' }
]

const tyyMissionType = [
  { id: '1', name: '口头检测' },
  { id: '2', name: '常规练习' },
  { id: '3', name: '双周测评' },
  { id: '4', name: '预约课程' },
  { id: '5', name: '补充练习' },
  { id: '6', name: '观看视频' }
]

const tyyTimeType = [
  { id: '1', name: '创建时间' },
  { id: '2', name: '支付时间' },
  { id: '3', name: '最后操作时间' }
]

const xxsCourseType = [
  { id: '1', name: '同步' },
  { id: '2', name: '培优' },
  { id: '3', name: '名师' },
  { id: '4', name: '拼音' }
]

const kipStatus = [
  { id: '1', name: '体验' },
  { id: '2', name: '新签' },
  { id: '3', name: '续费' }
]

const readStatus = [
  { id: '0', name: '非在读学生' },
  { id: '6', name: '在读学生' }
]

const questionType = [
  { id: 1, name: '单选题' },
  { id: 2, name: '多选题' },
  { id: 3, name: '简答' }
]
const timeStatus = {
  1: '月扣',
  2: '日扣',
  3: '周扣'
}

const courseKey = [
  { id: 210, name: '常规日扣' },
  { id: 201, name: '常规月扣' },
  { id: 401, name: '常规周扣' },
  { id: 310, name: '假期日扣' },
  { id: 301, name: '假期月扣' },
  { id: 501, name: '假期周扣' },
  { id: 601, name: '常规周末日扣' },
  { id: 701, name: '假期周末日扣' }
]

const subjectMap = [
  { id: 1, name: '慧表达' },
  { id: 3, name: '火花思维' },
  { id: 5, name: '国章书法' },
  { id: 6, name: '体能' },
  { id: 9, name: '控笔训练' },
  { id: 11, name: '幼儿通识' },
  { id: 12, name: '文学基础' },
  { id: 13, name: '幼鹰班技能' },
  { id: 14, name: '雏鹰班技能' },
  { id: 14, name: '成长班技能' }
]

const weekMap = [
  { id: 1, name: '周一' },
  { id: 2, name: '周二' },
  { id: 3, name: '周三' },
  { id: 4, name: '周四' },
  { id: 5, name: '周五' },
  { id: 6, name: '周六' },
  { id: 0, name: '周日' }
]

const luckyLevelMap = {
  1: '一等奖',
  2: '二等奖',
  3: '三等奖',
  4: '四等奖',
  5: '五等奖',
  6: '六等奖',
  7: '七等奖',
  8: '八等奖'
}

export default {
  OPEN_STATUS: openStatus,
  STOCK_TYPE: stockType,
  EXCHANGE_STATUS: stockExchangeStatus,
  OPINION_TYPES: opinionTypes,
  OPINION_STATUS: opinionStatus,
  TYY_PACKAGE_TYPE: tyyPakcageTypes,
  GRADE_LISTS: gradeLists,
  TYY_SUBJECT_LISTS: tyySubjectLists,
  TYY_MISSION_TYPE: tyyMissionType,
  TYY_TIME_TYPE: tyyTimeType,
  KPI_STATUS: kipStatus,
  READ_STATUS: readStatus,
  QUESTION_TYPE: questionType,
  XXS_COURSE_TYPE: xxsCourseType,
  XXS_SUBJECT_LISTS: xxsSubjectLists,
  TIME_STATUS: timeStatus,
  COURSE_KEY: courseKey,
  SUBJECT_MAP: subjectMap,
  WEEK_MAP: weekMap,
  LUCKY_LEVEL_MAP: luckyLevelMap,
  BUSSINESS_TYPE: businessType
}
